export default {"src":"/_next/static/media/empty-state-data.6354cc35.svg","height":94,"width":94,"blurWidth":0,"blurHeight":0};